import React, { useState } from 'react';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import DateObject from 'react-date-object';
import { subDays } from 'date-fns';

import './picker.css';

export function daysAgo(days) {
  return subDays(Date.now(), days).getTime();
}

// https://stackoverflow.com/questions/77150058/how-to-get-the-timezone-offset-for-a-specific-timezone
function getTimezoneOffsetMillis(timeZone) {
  let str;
  if (timeZone === null) {
    str = new Date().toLocaleString('en', { timeZoneName: 'longOffset' });
  } else {
    str = new Date().toLocaleString('en', { timeZone, timeZoneName: 'longOffset' });
  }
  const match = str.match(/([+-]\d+):(\d+)$/) || ['', '+00', '00'];
  const h = match[1];
  const m = match[2];
  return (h * 60 + (h > 0 ? +m : -m)) * 60 * 1000;
}

/**
 * Controlled component for choosing a date range
 */
const RangePicker = ({ from, to, error = false, onChange, timezone }) => {
  const localOffset = getTimezoneOffsetMillis(null);
  const desiredOffset = getTimezoneOffsetMillis(timezone);
  const [value, setValue] = useState(
    () => [
      new DateObject(from - localOffset + desiredOffset),
      new DateObject(to - localOffset + desiredOffset),
    ],
    [from, to, localOffset, desiredOffset]
  );
  const intermediateSet = (range) => {
    if (range.length === 2) {
      onChange({
        from: range[0].valueOf() - desiredOffset + localOffset,
        to: range[1].valueOf() - desiredOffset + localOffset,
      });
    }
    return setValue(range);
  };

  return (
    <span className={`RangePicker ${error ? 'error-state' : ''}`}>
      <DatePicker
        value={value}
        onChange={intermediateSet}
        // eslint-disable-next-line react-hooks/purity
        maxDate={new DateObject(Date.now() - localOffset + desiredOffset)}
        dateSeparator=" to "
        format="YYYY/MM/DD HH:mm"
        style={{ width: '250px' }}
        range
        rangeHover
        showOtherDays
        plugins={[<TimePicker key={1} position="right" hideSeconds />]}
      />{' '}
      {timezone}
    </span>
  );
};

export default RangePicker;
